import { type ModuleData, ModuleProvider, useModule } from '#providers'
import { CollectionEnvelope } from '@monthio/react-components'

interface BudgetCreatorConfig { 
	finishSession: () => Promise<void>
}

interface BudgetCreatorData {}

export type BudgetCreatorModuleData = ModuleData<
	BudgetCreatorData,
	void,
	BudgetCreatorConfig
>

export const BudgetCreatorModuleProvider: typeof ModuleProvider<BudgetCreatorModuleData> =
	ModuleProvider

export const useBudgetCreatorModule: typeof useModule<BudgetCreatorModuleData> =
	useModule
